import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IconModule } from '../icon/icon.module';
import { BreadcrumbComponent } from './breadcrumb.component';

@NgModule({
  imports: [CommonModule, IconModule, RouterModule],
  exports: [BreadcrumbComponent],
  declarations: [BreadcrumbComponent],
})
export class BreadcrumbModule {}
